var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgObra2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27475_40421)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27475_40421",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 140,
    height: 140
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.04 0H8.96C4.01153 0 0 3.85724 0 8.61539V131.385C0 136.143 4.01153 140 8.96 140H131.04C135.988 140 140 136.143 140 131.385V8.61539C140 3.85724 135.988 0 131.04 0Z",
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27475_40421)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9037 13.4717C30.7085 13.4717 27.3069 16.6463 27.3069 20.5622L22.0247 129.525C22.0247 133.44 25.4262 136.614 29.6214 136.614H156.579C160.775 136.614 164.176 133.44 164.176 129.525L157.382 4.45277C157.382 0.536847 153.981 -2.6377 149.785 -2.6377L34.9037 13.4717Z",
    fill: "#F0F2F1"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.645 146.663L116.687 123.927L149.95 123.548L152.454 146.663",
    fill: "#006B3F"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2599 45.1565C90.3673 44.2504 89.5442 43.2782 88.7977 42.2481C88.3302 41.6501 87.928 41.0036 87.5982 40.3196C87.2899 39.6039 87.0418 38.8637 86.8564 38.1067L85.578 33.4437C85.5537 33.3291 85.5537 33.2107 85.578 33.096C85.5993 32.9531 85.669 32.8218 85.7752 32.724C85.8815 32.6262 86.018 32.5678 86.162 32.5586C86.4595 32.5412 86.7542 32.6247 86.9984 32.7957C87.7314 33.3205 88.283 34.0608 88.5767 34.9138C88.9083 35.7199 89.3343 38.5335 90.7548 37.6009C90.9688 37.4413 91.1391 37.2302 91.2495 36.9869C91.3598 36.7436 91.4069 36.4763 91.3861 36.2099C91.3699 35.5815 91.116 34.9826 90.676 34.5344C90.0446 33.9021 89.0976 33.6493 88.5137 32.9537C88.2218 32.5788 88.0633 32.1171 88.0633 31.6418C88.0633 31.1664 88.2218 30.7048 88.5137 30.3298C88.2307 29.8582 88.0999 29.3105 88.1395 28.7616C88.179 28.2127 88.3869 27.6894 88.7347 27.2633C88.4234 27.0455 88.2011 26.7226 88.1082 26.3539C88.0155 25.9853 88.0585 25.5954 88.2295 25.2559C88.4059 24.9229 88.6632 24.6396 88.9777 24.4324C89.2921 24.2253 89.6536 24.1007 90.0288 24.0704C93.4064 23.7226 95.4897 28.0853 96.4998 30.646C97.2575 33.2589 98.5115 35.7009 100.193 37.838",
    fill: "#C1813E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M137.822 76.2978L110.668 53.8345L99.9605 35.105L87.6501 45.8163L103.679 68.9223C104.736 70.4584 106.021 71.8398 107.494 73.0232L122.77 85.3566",
    fill: "url(#paint0_linear_27475_40421)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M116.974 81.6741L117.103 83.3497L110.645 54.2036L134.686 73.7419",
    fill: "url(#paint1_linear_27475_40421)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6172 2.22391L87.4748 46.9324L87.2693 118.275V134.766C87.3036 135.059 87.4474 135.329 87.6734 135.525C87.8993 135.721 88.1916 135.829 88.4946 135.829C88.7975 135.829 89.0898 135.721 89.3158 135.525C89.5418 135.329 89.6856 135.059 89.7199 134.766L89.7989 90.1345L90.0202 18.7917L90.0677 2.22391C90.0335 1.93132 89.8896 1.66123 89.6636 1.46513C89.4376 1.26903 89.1453 1.16064 88.8424 1.16064C88.5395 1.16064 88.2472 1.26903 88.0211 1.46513C87.7952 1.66123 87.6513 1.93132 87.6172 2.22391Z",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1283 2.14897L59.0017 46.8574L58.7804 118.201V134.692C58.7804 135.009 58.9103 135.314 59.1416 135.539C59.3729 135.764 59.6865 135.89 60.0136 135.89C60.3407 135.89 60.6543 135.764 60.8855 135.539C61.1168 135.314 61.2468 135.009 61.2468 134.692L61.3732 89.9828L61.5946 18.6399V2.14897C61.5946 1.83105 61.4647 1.52613 61.2334 1.30131C61.0021 1.0765 60.6884 0.950195 60.3614 0.950195C60.0343 0.950195 59.7206 1.0765 59.4895 1.30131C59.2582 1.52613 59.1283 1.83105 59.1283 2.14897Z",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6221 13.0147L30.5115 50.4997L30.3375 109.916V123.672C30.3375 123.989 30.4674 124.294 30.6987 124.519C30.93 124.744 31.2436 124.87 31.5708 124.87C31.8978 124.87 32.2114 124.744 32.4427 124.519C32.674 124.294 32.8039 123.989 32.8039 123.672L32.9145 86.1712L33.0885 26.7547V13.0147C33.0885 12.6968 32.9585 12.3919 32.7273 12.1671C32.496 11.9422 32.1824 11.8159 31.8554 11.8159C31.5282 11.8159 31.2146 11.9422 30.9833 12.1671C30.752 12.3919 30.6221 12.6968 30.6221 13.0147Z",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M116.043 17.718L115.774 106.751V119.445C115.808 119.738 115.952 120.008 116.179 120.205C116.404 120.401 116.696 120.508 117 120.508C117.302 120.508 117.594 120.401 117.821 120.205C118.047 120.008 118.19 119.738 118.225 119.445L118.494 30.3974V17.718C118.459 17.4254 118.316 17.1553 118.089 16.9592C117.863 16.7631 117.571 16.6548 117.268 16.6548C116.965 16.6548 116.673 16.7631 116.448 16.9592C116.221 17.1553 116.077 17.4254 116.043 17.718Z",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7785 38.3411L58.8803 38.4793L132.445 38.6791H149.439C149.766 38.6791 150.08 38.5529 150.312 38.328C150.543 38.1033 150.673 37.7983 150.673 37.4804C150.673 37.1625 150.543 36.8575 150.312 36.6327C150.08 36.4079 149.766 36.2815 149.439 36.2815L103.338 36.1587L29.7741 36.0049H12.7785C12.4774 36.0383 12.1997 36.1781 11.9978 36.3977C11.7961 36.6174 11.6847 36.9015 11.6847 37.1961C11.6847 37.4905 11.7961 37.7747 11.9978 37.9944C12.1997 38.2141 12.4774 38.3539 12.7785 38.3871V38.3411Z",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.24097 88.3534L42.9754 88.461L104.776 88.5993H119.006C119.307 88.566 119.585 88.4262 119.786 88.2065C119.988 87.9868 120.099 87.7026 120.099 87.4082C120.099 87.1137 119.988 86.8296 119.786 86.6099C119.585 86.3902 119.307 86.2504 119.006 86.2171L80.2869 86.1095L18.5332 86.002H4.30422C4.00324 86.0352 3.72539 86.175 3.52367 86.3947C3.32193 86.6144 3.21045 86.8985 3.21045 87.193C3.21045 87.4875 3.32193 87.7717 3.52367 87.9914C3.72539 88.211 4.00324 88.3508 4.30422 88.3841L4.24097 88.3534Z",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4781 113.346L55.2125 113.453L117.013 113.622H131.243C131.57 113.622 131.883 113.496 132.114 113.271C132.346 113.047 132.476 112.741 132.476 112.423C132.476 112.105 132.346 111.801 132.114 111.576C131.883 111.351 131.57 111.225 131.243 111.225L92.5082 111.117L30.707 110.948H16.4781C16.1511 110.948 15.8374 111.074 15.6061 111.299C15.3748 111.524 15.2449 111.829 15.2449 112.146C15.2449 112.465 15.3748 112.77 15.6061 112.994C15.8374 113.219 16.1511 113.346 16.4781 113.346Z",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37929 63.3316L50.4852 63.4546L116.476 63.639H131.574C131.875 63.6057 132.153 63.4659 132.355 63.2462C132.556 63.0265 132.668 62.7423 132.668 62.4479C132.668 62.1535 132.556 61.8693 132.355 61.6496C132.153 61.4299 131.875 61.2901 131.574 61.2568L90.4685 61.1339L24.5252 60.9341H9.37929C9.07831 60.9674 8.80047 61.1071 8.59874 61.3268C8.39702 61.5465 8.28552 61.8307 8.28552 62.1252C8.28552 62.4196 8.39702 62.7038 8.59874 62.9235C8.80047 63.1432 9.07831 63.283 9.37929 63.3162V63.3316Z",
    fill: "#AC41D8"
  })))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7762 121.541L73.0108 121.791C70.4057 121.925 67.8483 122.161 65.2433 122.294C64.6555 122.294 63.8772 122.53 63.8772 123.076C63.8982 123.225 63.9586 123.366 64.0529 123.488C64.1472 123.608 64.2724 123.706 64.4173 123.771C65.143 124.099 65.9205 124.319 66.7206 124.42C67.119 124.478 67.4963 124.626 67.82 124.85C68.1437 125.074 68.4042 125.367 68.579 125.705C68.6675 126.156 68.6053 126.621 68.4008 127.038C68.1964 127.455 67.8594 127.804 67.4354 128.038C66.6093 128.552 65.6682 128.886 64.6833 129.014C63.6983 129.143 62.695 129.061 61.7487 128.776C61.23 128.633 60.6984 128.534 60.1602 128.481C59.8981 128.46 59.6341 128.492 59.3871 128.577C59.1401 128.661 58.916 128.795 58.7306 128.968C58.5249 129.257 58.406 129.591 58.3866 129.936C58.367 130.282 58.4474 130.625 58.6194 130.932C59.144 132.005 59.9292 132.951 60.9132 133.694C61.8972 134.437 63.0532 134.957 64.2902 135.214C69.4527 136.499 75.4094 134.387 80.3336 132.837",
    fill: "#C1813E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M125.035 83.3476L121.611 73.9704C119.773 73.0312 118.201 72.4556 116.442 71.4406C115.322 70.9378 114.417 70.0758 113.882 69.0016C113.745 68.3393 113.747 67.657 113.891 66.9957C114.034 66.3346 114.314 65.708 114.714 65.1539C115.61 63.5177 116.583 61.912 117.636 60.3516C116.851 59.8517 115.97 59.1397 116.066 58.2308C116.16 57.3218 116.851 57.0643 117.479 56.7158L122.081 53.9436C123.321 53.0985 124.674 52.4205 126.103 51.9288C126.904 51.7042 127.724 51.547 128.554 51.4593C130.732 51.0155 132.992 51.1146 135.119 51.747C136.678 52.2256 138.059 53.1309 139.094 54.3526C140.013 55.692 140.613 57.2124 140.847 58.8031C141.08 60.394 140.943 62.015 140.445 63.5481C139.42 66.615 137.622 69.3892 135.214 71.6224L138.669 78.9393",
    fill: "#C1813E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M121.621 59.2272C121.909 59.2272 122.143 59.0022 122.143 58.7247C122.143 58.4471 121.909 58.2222 121.621 58.2222C121.332 58.2222 121.098 58.4471 121.098 58.7247C121.098 59.0022 121.332 59.2272 121.621 59.2272Z",
    fill: "#2B2B2B"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M117.194 63.1174C117.57 63.3582 117.994 63.5185 118.439 63.5873C118.882 63.6561 119.337 63.632 119.772 63.5166C119.849 63.4942 119.914 63.4429 119.953 63.3737C119.991 63.3046 120 63.2235 119.977 63.1481C119.954 63.0727 119.9 63.0094 119.83 62.972C119.758 62.9346 119.675 62.9262 119.598 62.9485C119.24 63.0443 118.863 63.0624 118.498 63.0013C118.132 62.9403 117.784 62.8017 117.479 62.5953C117.163 62.3804 116.879 62.9025 117.194 63.1174Z",
    fill: "#C1813E"
  })))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M131.83 74.9051L114.235 81.5253C112.439 82.2057 110.842 83.2929 109.578 84.6948C108.314 86.0966 107.42 87.7715 106.972 89.5771L103.773 102.463C103.455 103.752 102.866 104.964 102.04 106.023C101.214 107.083 100.17 107.967 98.9738 108.622L75.1074 121.262L81.506 135.609L114.778 120.538L114.171 130.745L151.41 130.437V110.422C151.441 99.3865 148.58 88.5208 143.091 78.831C142.031 76.9713 140.303 75.5471 138.229 74.8245C136.157 74.102 133.883 74.1307 131.83 74.9051Z",
    fill: "#00D38D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M131.83 74.9051L114.235 81.5253C112.439 82.2057 110.842 83.2929 109.578 84.6948C108.314 86.0966 107.42 87.7715 106.972 89.5771L103.773 102.463C103.455 103.752 102.866 104.964 102.04 106.023C101.214 107.083 100.17 107.967 98.9738 108.622L75.1074 121.262L81.506 135.609L114.778 120.538L114.171 130.745L151.41 130.437V110.422C151.441 99.3865 148.58 88.5208 143.091 78.831C142.031 76.9713 140.303 75.5471 138.229 74.8245C136.157 74.102 133.883 74.1307 131.83 74.9051Z",
    fill: "url(#paint2_linear_27475_40421)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M138.58 70.4829C139.628 69.0871 140.66 67.723 141.806 66.4382C142.896 65.2582 143.671 63.8302 144.063 62.2824C144.103 61.8445 144.103 61.4038 144.063 60.9658C144.062 59.01 143.328 57.1233 141.998 55.668C140.634 54.0254 138.87 52.7486 136.87 51.9564C135.37 51.3853 133.757 51.1474 132.321 50.3702C129.951 49.1963 128.016 47.3406 125.484 46.4523C124.896 46.1989 124.248 46.1078 123.612 46.1889C122.976 46.2699 122.374 46.5201 121.871 46.9123C121.498 47.3015 121.247 47.7881 121.146 48.3139C121.046 48.8398 121.102 49.3829 121.306 49.8785C122.419 52.7336 128.677 53.0509 128.258 56.8417C128.095 57.512 127.828 58.1539 127.467 58.7452C127.288 59.0372 127.193 59.3718 127.193 59.7128C127.193 60.0539 127.288 60.3884 127.467 60.6803C127.657 60.8623 127.886 60.9986 128.138 61.0784C128.39 61.1582 128.658 61.1794 128.919 61.1404C129.677 61.1404 130.532 60.6169 131.29 60.9024C131.754 61.1099 132.139 61.4564 132.391 61.8922C132.643 62.328 132.749 62.8309 132.693 63.3292C132.622 63.8295 132.44 64.3084 132.161 64.7328C131.882 65.1573 131.514 65.5173 131.08 65.7879C130.226 66.3341 129.254 66.6763 128.241 66.7871C127.937 66.8208 127.634 66.8792 127.339 66.9616C127.025 67.8497 126.898 68.7911 126.964 69.7288C127.031 70.6665 127.29 71.5814 127.726 72.4181C128.194 73.0037 128.791 73.4767 129.473 73.8009C130.155 74.1253 130.903 74.2924 131.661 74.2898C133.006 74.3625 134.347 74.0834 135.547 73.4809C136.792 72.7401 137.833 71.7108 138.58 70.4829Z",
    fill: "#2B2B2B"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M121.098 74.3027L125.279 75.1621L122.033 76.3128",
    fill: "#C1813E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0875 38.1211H33.2233L30.0875 42.1412",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3676 38.1211H61.4446L59.3541 42.1412",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M115.817 39.1265H118.933L115.797 42.1415",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1076 63.2471H33.2233L30.0875 67.2672",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3675 63.2471H61.4446L59.3541 67.2672",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5754 63.2471H89.6659L87.5754 67.2672",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1077 88.375H33.2233L30.0875 92.3952",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3289 88.375H61.4445L58.3088 92.3952",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5888 88.375H89.6659L87.5754 92.3952",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1077 113.498H33.2233L30.0875 117.518",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3288 113.498H61.4445L58.3088 117.518",
    fill: "#AC41D8"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27475_40421",
    x1: 137.841,
    y1: 60.2024,
    x2: 87.6691,
    y2: 60.2024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B01A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_27475_40421",
    x1: 134.695,
    y1: 68.7602,
    x2: 110.654,
    y2: 68.7602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B01A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_27475_40421",
    x1: 151.44,
    y1: 104.921,
    x2: 75.1363,
    y2: 104.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B01A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27475_40421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgObra2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/obra2.a352d835119e16d130aed0dffd7e45ed.svg";